import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit, OnChanges {

  @Input() tabs: Array<any>;
  @Input() formTab = false;
  @Input() selectedTab: string;
  @Input() showSubTab = false;
  @Input() showCount = false;
  @Input() mapID = false;
  @Output() onTabSelect = new EventEmitter();
  @Output() onTabObjSelect = new EventEmitter();
  selected = 0;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tabs && changes.tabs.currentValue && changes.tabs.currentValue.length) {
      this.onSelect(0);
    }

    if (changes.selectedTab && changes.selectedTab.currentValue) {
      if (this.mapID) {
        const index = this.tabs.findIndex((x) => x.id === this.selectedTab);
        if (index > -1) {
          this.selected = index;
        }
      } else {
        const index = this.tabs.findIndex((x) => x.name === this.selectedTab);
        if (index > -1) {
          this.selected = index;
        }
      }
    }
  }

  ngOnInit(): void {
  }

  onSelect(selectedTabIndex, fromUI?: boolean): void {
    if (!this.tabs[selectedTabIndex].disable) {
      if (this.mapID) {
        this.onTabSelect.emit(this.tabs[selectedTabIndex].id);
        if (fromUI) {
          if (this.tabs[this.selected].id !== this.tabs[selectedTabIndex].id) {
          this.onTabObjSelect.emit(this.tabs[selectedTabIndex]);
          }
        }
      } else {
        this.onTabSelect.emit(this.tabs[selectedTabIndex].name);
        if (fromUI) {
          if (this.tabs[this.selected].name !== this.tabs[selectedTabIndex].name) {
          this.onTabObjSelect.emit(this.tabs[selectedTabIndex]);
          }
        }
      }
      this.selected = selectedTabIndex;
    }
  }

}
